import React from 'react';
import { 
  FaHistory, 
  FaUsers, 
  FaCar, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope,
  FaClock,
  FaHeart,
  FaShieldAlt,
  FaStar,
  FaCheck,
  FaThumbsUp,
  FaRoad
} from 'react-icons/fa';
import { 
  MdLocalTaxi, 
  MdCheckCircle,
  MdLocationOn,
  MdAirportShuttle,
  MdTempleHindu,
  MdDirectionsBoat
} from 'react-icons/md';
import '../style.css';

const About = () => {
  const values = [
    { 
      icon: <FaShieldAlt />, 
      title: "Safety First", 
      description: "GPS tracking & verified drivers" 
    },
    { 
      icon: <FaClock />, 
      title: "Punctuality", 
      description: "On-time service guaranteed" 
    },
    { 
      icon: <FaHeart />, 
      title: "Customer Care", 
      description: "24/7 multi-language support" 
    },
    { 
      icon: <FaRoad />, 
      title: "Clean Vehicles", 
      description: "Daily sanitization" 
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section - Desktop Split */}
      <section className="hero-desktop">
        <div className="container">
          <div className="hero-wrapper">
            <div className="hero-content-side">
              <div className="hero-badge">
                <span>VNS Tour And Travels </span>
              </div>
              <h1 className="hero-main-title">
                Your Trusted Travel Partner in
                <span className="highlight"> Varanasi</span>
              </h1>
              <p className="hero-description">
                Founded in 2010, we've been serving the spiritual capital of India with reliable, 
                safe, and comfortable transportation services for residents, pilgrims, and tourists.
              </p>
              
              <div className="hero-stats-desktop">
                <div className="stat-box">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Vehicles</div>
                </div>
                <div className="stat-box">
                  <div className="stat-number">50K+</div>
                  <div className="stat-label">Happy Customers</div>
                </div>
                <div className="stat-box">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Service</div>
                </div>
                <div className="stat-box">
                  <div className="stat-number">100+</div>
                  <div className="stat-label">Drivers</div>
                </div>
              </div>
              
              <div className="hero-buttons">
                <button className="primary-btn">
                  <MdLocalTaxi /> Book a Cab
                </button>
                <button className="secondary-btn">
                  <FaPhone /> Call Now
                </button>
              </div>
            </div>
            
            <div className="hero-image-side">
              <div className="image-container">
                <img 
                  src="https://s7ap1.scene7.com/is/image/incredibleindia/dashashwamedh-ghat-varanasi-uttar-pradesh-city-hero?qlt=82&ts=1727959374496"
                  alt="Varanasi Ghats"
                  className="main-hero-image"
                />
                <div className="image-overlay">
                  <div className="overlay-badge">
                    <FaStar />
                    <span>Serving Since 2010</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story - Desktop Side by Side */}
      <section className="story-desktop">
        <div className="container">
          <div className="story-header">
            <div className="section-title">
              <FaHistory className="title-icon" />
              <h2>Our Journey in Varanasi</h2>
            </div>
            <p className="section-subtitle">From 5 cars to 500+ vehicles across the city</p>
          </div>
          
          <div className="story-content-desktop">
            <div className="story-text-side">
              <div className="story-points">
                <div className="story-point">
                  <div className="point-icon">
                    <FaCar />
                  </div>
                  <div className="point-content">
                    <h3>Humble Beginnings</h3>
                    <p>Started in 2010 with just 5 cars, serving local residents and pilgrims.</p>
                  </div>
                </div>
                
                <div className="story-point">
                  <div className="point-icon">
                    <MdAirportShuttle />
                  </div>
                  <div className="point-content">
                    <h3>Airport Service Launch</h3>
                    <p>Expanded to airport transfers in 2015 for international visitors.</p>
                  </div>
                </div>
                
                <div className="story-point">
                  <div className="point-icon">
                    <FaThumbsUp />
                  </div>
                  <div className="point-content">
                    <h3>Trusted Service</h3>
                    <p>Became Varanasi's most trusted cab service with 50,000+ customers.</p>
                  </div>
                </div>
              </div>
              
              <div className="story-quote">
                <div className="quote-icon">"</div>
                <p>Understanding Varanasi's unique transportation needs - from temple tours 
                for pilgrims to reliable daily commutes for residents.</p>
              </div>
            </div>
            
            <div className="story-image-side">
              <div className="story-image-wrapper">
                <img 
                  src="https://visitkashi.com/images/rammandir.jpg"
                  alt="Varanasi Temple"
                  className="story-image"
                />
                
                
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section - Desktop Grid */}
      <section className="values-desktop">
        <div className="container">
          <div className="section-header-desktop">
            <h2>Why Choose Kashi Cab?</h2>
            <p className="section-description">Premium services tailored for Varanasi's unique needs</p>
          </div>
          
          <div className="values-grid-desktop">
            <div className="value-card-desktop">
              <div className="value-icon-desktop" style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)' }}>
                <FaShieldAlt />
              </div>
              <h3>Safety & Security</h3>
              <ul className="value-list">
                <li><MdCheckCircle /> GPS Tracking</li>
                <li><MdCheckCircle /> Verified Drivers</li>
                <li><MdCheckCircle /> 24/7 Monitoring</li>
              </ul>
            </div>
            
            <div className="value-card-desktop">
              <div className="value-icon-desktop" style={{ background: 'linear-gradient(135deg, #FF6B6B, #FF8E8E)' }}>
                <FaClock />
              </div>
              <h3>Punctuality</h3>
              <ul className="value-list">
                <li><MdCheckCircle /> Real-time Tracking</li>
                <li><MdCheckCircle /> Flight Monitoring</li>
                <li><MdCheckCircle /> On-time Guarantee</li>
              </ul>
            </div>
            
            <div className="value-card-desktop">
              <div className="value-icon-desktop" style={{ background: 'linear-gradient(135deg, #4CAF50, #45a049)' }}>
                <FaHeart />
              </div>
              <h3>Customer Care</h3>
              <ul className="value-list">
                <li><MdCheckCircle /> 24/7 Support</li>
                <li><MdCheckCircle /> Multi-language</li>
                <li><MdCheckCircle /> Quick Response</li>
              </ul>
            </div>
            
            <div className="value-card-desktop">
              <div className="value-icon-desktop" style={{ background: 'linear-gradient(135deg, #FFD700, #FFC107)' }}>
                <FaRoad />
              </div>
              <h3>Premium Fleet</h3>
              <ul className="value-list">
                <li><MdCheckCircle /> Daily Sanitization</li>
                <li><MdCheckCircle /> Regular Maintenance</li>
                <li><MdCheckCircle /> Comfort & Cleanliness</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Special Services - Desktop Cards */}
      <section className="services-desktop">
        <div className="container">
          <div className="section-header-desktop">
            <h2>Special Varanasi Services</h2>
            <p className="section-description">Tailored packages for pilgrims and tourists</p>
          </div>
          
          <div className="services-grid-desktop">
            <div className="service-card-desktop">
              <div className="service-image-container">
                <img 
                  src="https://experiencemyindia.com/wp-content/uploads/2024/08/2-9-768x354.jpg.webp"
                  alt="Temple Tour"
                />
                <div className="service-category">
                  <MdTempleHindu /> Temple Tour
                </div>
              </div>
              <div className="service-content">
                <h3>Temple Darshan Packages</h3>
                <p>Complete spiritual journey covering Kashi Vishwanath, Sankat Mochan, and Durga Temple</p>
                <div className="service-features-grid">
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>4-Hour Basic</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>8-Hour Complete</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Multi-Day Pilgrimage</span>
                  </div>
                </div>
                <div className="service-footer">
                  <span className="service-price">Starting from ₹1,500</span>
                  <button className="service-btn">Book Package</button>
                </div>
              </div>
            </div>
            
            <div className="service-card-desktop">
              <div className="service-image-container">
                <img 
                  src="https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                  alt="Airport Transfer"
                />
                <div className="service-category">
                  <MdAirportShuttle /> Airport Transfer
                </div>
              </div>
              <div className="service-content">
                <h3>Airport Transfers</h3>
                <p>Lal Bahadur Shastri Airport (VNS) to any location in Varanasi with premium service</p>
                <div className="service-features-grid">
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Flight Tracking</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Meet & Greet</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Multilingual Drivers</span>
                  </div>
                </div>
                <div className="service-footer">
                  <span className="service-price">Starting from ₹800</span>
                  <button className="service-btn">Book Transfer</button>
                </div>
              </div>
            </div>
            
            <div className="service-card-desktop">
              <div className="service-image-container">
                <img 
                  src="https://kashiyatra.in/wp-content/uploads/2023/04/varanasi-tour-package.jpg"
                  alt="Ganga Aarti"
                />
                <div className="service-category">
                  <MdDirectionsBoat /> Ganga Aarti
                </div>
              </div>
              <div className="service-content">
                <h3>Ganga Aarti Special</h3>
                <p>Experience the magical evening aarti at Dashashwamedh Ghat with premium services</p>
                <div className="service-features-grid">
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Aarti Pickup & Drop</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Boat Ghat Transfer</span>
                  </div>
                  <div className="feature-item">
                    <MdCheckCircle />
                    <span>Guided Tour</span>
                  </div>
                </div>
                <div className="service-footer">
                  <span className="service-price">Starting from ₹1,200</span>
                  <button className="service-btn">Book Experience</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Desktop Layout */}
      <section className="contact-desktop">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info-side">
              <div className="contact-header">
                <div className="contact-title">
                  <FaMapMarkerAlt className="contact-title-icon" />
                  <h2></h2>
                </div>
                <p>Visit our office or get in touch for premium cab services</p>
              </div>
              
              <div className="contact-details-grid">
                <div className="contact-detail-card">
                  <div className="contact-icon-wrapper">
                    <MdLocationOn />
                  </div>
                  <div className="contact-detail-content">
                    <h4>Head Office</h4>
                    <p className="address-detail"> G.T road Mohansarai bypas Rajatalab Varanasi UP-221302</p>
                  </div>
                </div>
                
                <div className="contact-detail-card">
                  <div className="contact-icon-wrapper">
                    <FaPhone />
                  </div>
                  <div className="contact-detail-content">
                    <h4>Call Us</h4>
                    <p className="phone-number">6307291567
</p>
                    <p className="phone-sub">6307291567
</p>
                  </div>
                </div>
                
                <div className="contact-detail-card">
                  <div className="contact-icon-wrapper">
                    <FaEnvelope />
                  </div>
                  <div className="contact-detail-content">
                    <h4>Email Us</h4>
                    <p>vnstoursandtravels9696@gmail.com</p>
                  </div>
                </div>
              </div>
              
              <div className="contact-cta">
                <button className="cta-call">
                  <FaPhone /> Call Now
                </button>
                <button className="cta-whatsapp">
                  <span className="whatsapp-icon"></span> WhatsApp
                </button>
              </div>
            </div>
            
            <div className="contact-map-side">
  <div className="map-container-desktop">
    <iframe
      title="G.T road Mohansarai bypas Rajatalab Varanasi UP-221302"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.928452024744!2d82.870167!3d25.31071!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDE4JzM4LjYiTiA4MsKwNTInMTIuNiJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
      width="100%"
      height="100%"
      style={{ border: 0, borderRadius: '12px' }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
    <div className="map-overlay">
      <div className="map-badge">
        <FaCar />
        <span>VNS Tour And Travels</span>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </section>

     
    </div>
  );
};

export default About;